import * as styles from "./banner-info.module.css";

interface BannerInfoProps {
  text: string;
}

export const BannerInfo = ({ text }: BannerInfoProps) => {
  return <div className={styles.banner}>{text}</div>;
};
